import { Dayjs } from "dayjs"
import { Status } from "@/types/Status"

export enum ReadingSource {
  System = "System",
  Customer = "Customer",
  Smart = "SMR",
  Manual = "MMR",
  Industry = "Industry",
  User = "User",
}

export enum ReadingSequenceType {
  Normal = "Normal",
  First = "First",
  Last = "Last",
}

export interface IReading {
  id: number
  unit: string
  quality: string
  cumulative: number
  date: Dayjs
  source: ReadingSource
  sequenceType: ReadingSequenceType
  consumption: number
  statusCode: string
  rateName?: string
  meterIdentifier?: string

  readonly isManualReading: boolean
  readonly isSmartReading: boolean
  readonly isCustomerReading: boolean
  readonly isOfTypeFirst: boolean
  readonly isEstimated: boolean
  readonly isSystemReading: boolean
  readonly status: Status
  readonly dateStatus: Status
  readonly kwhConversionFactor: number
}
